<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Welcome!</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="content">
    <p>
      Kindly complete the verification process. <br/>
      Tap <a (click)="goTo('documents-verification')" class="tw-text-blue-600"> here </a>
      to complete the Verify Documents!"
    </p>
  </div>
</ion-content>
